<template>
  <Modal
    v-model="BoolModal"
    :title="statusId"
    closable
    width="600"
    :footer-hide="true"
    :mask-closable="true"
    draggable
  >
    <div class="order-content">
      <!-- <h3 class="h_header" v-if="trackeData.length > 0">
        {{ trackeData[0].remarks }}:
        {{ trackeData[0].createTime }}
      </h3> -->
      <div class="step-time">
        <!-- <Timeline>
          <TimelineItem>
            <p>END</p>
          </TimelineItem>
          <TimelineItem
            v-for="item in trackeData"
            :key="item.id"
            :color="item.is_exception ? 'red' : 'green'"
          >
            <template v-if="item.is_exception">
              <p class="time text-red">{{ item.remarks }}</p>
              <p class="content text-red">
                {{ item.location }}——{{ item.createTime }}
              </p>
            </template>
            <template v-else>
              <p class="time">{{ item.remarks }}</p>
              <p class="content">{{ item.location }}——{{ item.createTime }}</p>
            </template>
          </TimelineItem>
          <TimelineItem>
            <p>START</p>
          </TimelineItem>
        </Timeline> -->
        <Timeline>
          <TimelineItem>
            <p>END</p>
          </TimelineItem>
          <TimelineItem v-for="item in trackeData" :key="item.id">
            <p class="time">{{ item.createTime }}</p>
            <p class="content">
              <span> {{ $t("tracker_code") }}: </span>
              {{ item.status }}
            </p>
            <p class="content">
              <span>{{ $t("status_location") }}: </span>
              {{ item.location }}
            </p>
            <p class="content">
              <span>{{ $t("tracker_description") }}: </span>
              {{ item.remarks }}
            </p>
          </TimelineItem>
          <TimelineItem>
            <p>START</p>
          </TimelineItem>
        </Timeline>
      </div>
    </div>
  </Modal>
</template>

<script>
import { getOrderStatus } from "@/api/order/list";
export default {
  props: {
    statusId: {
      type: String,
    },
  },
  data() {
    return {
      trackeData: [],
      BoolModal: false,
    };
  },
  mounted() {},
  methods: {
    open(id) {
      this.trackeData = [];
      this.seachtrack(id);
      this.BoolModal = true;
    },
    close() {},
    seachtrack(id) {
      getOrderStatus(id).then((res) => {
        if (res.data.status) {
          this.trackeData = res.data.tracker;
        } else {
          this.$Message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style>
.time {
  font-size: 16px;
  font-weight: bold;
}
.text-red {
  color: red;
}
.content {
  padding-left: 10px;
  margin: 10px 0;
  font-size: 14px;
}
.ivu-timeline-item {
  padding: 0;
}
.order-content {
  min-height: 400px;
  max-height: 600px;
  overflow: auto;
}
.step-time {
  width: 70%;
  margin: 0 auto;
}
.h_header {
  font-size: 18px;
  margin-bottom: 20px;
  border-bottom: 3px solid #19be6b;
  font-weight: bold;
  border-radius: 3px;
}
</style>
